import { useState } from 'react';
import { TabNav } from '@bwoty-web/styleguide2/tab-nav';
import PropTypes from 'prop-types';
import ContentWrapper from './contentWrapper';
import './accommodationConceptContent.scss';
import { updateUrlWithOpenHotelSection } from '../../../../../utils/url';

const AccommodationConceptContent = ({
  conceptContent,
  labels,
  toggleRoomInfo,
  selectedSubSection,
}) => {
  const [selectedTab, setSelectedTab] = useState(selectedSubSection);

  if (!conceptContent) {
    return null;
  }

  const tabs = conceptContent.map((fs, index) => ({
    value: fs.heading || '',
    index: index.toString(),
  }));

  if (!tabs.length) {
    return null;
  }

  return (
    <>
      {tabs.length > 1 && (
        <TabNav
          onClick={(i) => {
            setSelectedTab(i);
            updateUrlWithOpenHotelSection(`accommodation:${i}`);
          }}
          tabs={tabs}
          selected={selectedTab}
        />
      )}
      {conceptContent.map((content, i) => (
        <ContentWrapper
          key={content.heading}
          texts={labels}
          selected={i === selectedTab}
          index={i}
          content={content}
          toggleRoomInfo={toggleRoomInfo}
          tabsExist={tabs.length > 1}
        />
      ))}
    </>
  );
};

AccommodationConceptContent.propTypes = {
  conceptContent: PropTypes.arrayOf(PropTypes.shape({})),
  labels: PropTypes.shape({}),
  toggleRoomInfo: PropTypes.func.isRequired,
  selectedSubSection: PropTypes.number,
};

AccommodationConceptContent.defaultProps = {
  conceptContent: [],
  labels: null,
  selectedSubSection: 0,
};

export default AccommodationConceptContent;
